import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'pop-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.less']
})
export class CheckboxComponent {
  @Input()
  public disabled = false;

  private _isChecked: boolean | undefined;
  @Input()
  public get isChecked() {
    return this._isChecked;
  }
  public set isChecked(value: boolean | undefined) {
    const isInitialValue = this._isChecked === undefined;
    if (this._isChecked === value) {
      return;
    }
    this._isChecked = value;
    if (isInitialValue) {
      return;
    }
    this.isCheckedChange.emit(value);
  }


  @Output()
  public isCheckedChange = new EventEmitter<boolean>();

  

  private static Counter = 1;

  public id = `pop_checkbox_${CheckboxComponent.Counter++}`;
}
